import { render } from "./FactFormula.vue?vue&type=template&id=51166708&scoped=true"
import script from "./FactFormula.vue?vue&type=script&lang=js"
export * from "./FactFormula.vue?vue&type=script&lang=js"

import "./FactFormula.vue?vue&type=style&index=0&id=51166708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51166708"]])

export default __exports__